import * as XLSX from 'xlsx';

const cmmUtils = {
  excelDownload: (rows, fileName, columns, columnNm) => {
    let result;

    // 입력받은 컬럼이 있는경우 컬럼에 해당하는 데이터만 내보내기 위함. 아닌경우 전체 출력
    if (!!columns) {
      result = rows.map((row) => {
        let newData = {};
        columns.forEach((col) => {
          newData[col.id] = row[col.id];
        });
        return newData;
      });
    } else {
      result = [...rows];
    }

    if (columnNm) {
      let arrIdNm = {};
      columns.forEach((col) => {
        arrIdNm[col.id] = col.id;
      });
      result.unshift(arrIdNm);
    }

    let ws = XLSX.utils.json_to_sheet(result);
    let wb = XLSX.utils.book_new();

    columns?.forEach((column, idx) => {
      let cellChange = XLSX.utils.encode_cell({ c: idx, r: 0 });
      ws[cellChange].v = column.label;
    });

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  },
  csvToJSON: (csvString) => {
    const rows = csvString.split('\r\n');
    const jsonArray = [];
    const header = rows[0].split(',');

    for (let i = 1; i < rows.length; i++) {
      if (rows[i]) {
        let obj = {};
        let row = rows[i].split(',');

        for (let j = 0; j < header.length; j++) {
          obj[header[j]] = row[j];
        }
        jsonArray.push(obj);
      }
    }
    return jsonArray;
  }
};

export { cmmUtils };
